import { useDispatch } from "react-redux";
import { setProfile } from "features/user/userSlice";
import api from "utils/api";
import { useSignOutUser } from "hooks";

export default function useFetchProfile() {
  const dispatch = useDispatch();
  const handleSignOut = useSignOutUser();

  const fetchProfile = async (firebaseToken) => {
    try {
      const response = await api.getProfile(firebaseToken);
      dispatch(setProfile(response.data));
      return response.data;
    } catch (e) {
      if (e.response.status === 401) {
        // Clear any state
        handleSignOut();
      } else {
        console.error(e);
      }
    }
  };

  return { fetchProfile };
}
